import { render, staticRenderFns } from "./AddMaintenanceDay.vue?vue&type=template&id=2fb85492&scoped=true&"
import script from "./AddMaintenanceDay.vue?vue&type=script&lang=ts&"
export * from "./AddMaintenanceDay.vue?vue&type=script&lang=ts&"
import style0 from "./AddMaintenanceDay.vue?vue&type=style&index=0&id=2fb85492&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb85492",
  null
  
)

export default component.exports